import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Cloud, Mail, LogIn, LogOut, LayoutDashboard, Globe, ShieldCheck } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { LoginModal } from '@/components/auth/LoginModal';
import { useAuthStore } from '@/lib/auth-store';
import { toast } from 'sonner';
interface HeaderProps {
  onOpenSetup?: () => void;
}
export function Header({ onOpenSetup }: HeaderProps) {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  // ZUSTAND ZERO-TOLERANCE: One field per store call
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const logout = useAuthStore((s) => s.logout);
  const handleLogout = () => {
    logout();
    toast.info('Đã đăng xuất thành công.');
  };
  return (
    <header className="sticky top-0 z-50 w-full border-b border-white/10 bg-background/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-2">
            <Link to="/" className="flex items-center gap-2 hover:opacity-90 transition-opacity">
              <div className="relative">
                <Cloud className="h-8 w-8 text-primary" />
                <Mail className="absolute -bottom-1 -right-1 h-4 w-4 text-white" />
              </div>
              <span className="text-xl font-bold tracking-tight hidden sm:block">
                CLOUD<span className="text-primary">TEMPMAIL</span>
              </span>
            </Link>
          </div>
          <nav className="hidden md:flex items-center gap-8">
            <Link to="/" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">Trang chủ</Link>
            <button 
              onClick={onOpenSetup}
              className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5"
            >
              <Globe className="h-3.5 w-3.5" />
              Kết nối Domain
            </button>
            {isAuthenticated && (
              <Link to="/admin" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors flex items-center gap-1.5">
                <LayoutDashboard className="h-3.5 w-3.5" />
                Quản trị
              </Link>
            )}
            <div className="flex items-center gap-1.5 px-2 py-1 rounded-full bg-green-500/10 text-[10px] font-bold text-green-500 uppercase tracking-tight">
              <ShieldCheck className="h-3 w-3" />
              Hệ thống ổn định
            </div>
          </nav>
          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <Button variant="ghost" size="sm" onClick={handleLogout} className="flex gap-2 text-destructive hover:text-destructive hover:bg-destructive/10">
                <LogOut className="h-4 w-4" />
                Đăng xuất
              </Button>
            ) : (
              <Button variant="ghost" size="sm" onClick={() => setIsLoginOpen(true)} className="flex gap-2">
                <LogIn className="h-4 w-4" />
                <span className="hidden sm:inline">Quản trị</span>
              </Button>
            )}
            <Button size="sm" className="btn-purple hidden sm:flex" onClick={onOpenSetup}>
              Bắt đầu ngay
            </Button>
          </div>
        </div>
      </div>
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </header>
  );
}